import { BaseClient } from '../client';

interface userDeleteAccountProps {
	idUsuario: number;
	motivoEncerramento: string;
}

export const postUserDeleteAccount = async (body: userDeleteAccountProps) => {
	if (process.env.NODE_ENV === 'development') {
		return 'Sucesso';
	}

	try {
		const response = await BaseClient.post<string>(`/Usuarios/DeleteAccount`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
